import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.testSolutionSet, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_TEST_SOLUTIONSET}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    // Todo: Check and remove this
    case `${ActionTypes.GET_API_V1_TEST_SOLUTIONSET}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    case ActionTypes.UPDATE_ADAPTIVE_CURRENT_PROBLEM: {
      const { problemId, problemSlug } = action.payload || {};
      const sections = Array.isArray(state?.sections) ? state.sections : [];
      if (!sections.length || !problemId || !problemSlug) return state;

      const updatedSections = sections.map(sec => {
        if (sec?.status !== 'CTK') return sec;
        const prevProblemIds = Array.isArray(sec?.problem_ids)
          ? sec.problem_ids
          : [];
        const prevProblemSlugs = Array.isArray(sec?.problems)
          ? sec.problems
          : [];
        const nextProblemIds = prevProblemIds.includes(problemId)
          ? prevProblemIds
          : prevProblemIds.concat(problemId);

        const nextProblemSlugs = prevProblemSlugs.includes(problemSlug)
          ? prevProblemSlugs
          : prevProblemSlugs.concat(problemSlug);

        return {
          ...sec,
          current_problem_id: problemId,
          current_problem_slug: problemSlug,
          problem_ids: nextProblemIds,
          problems: nextProblemSlugs,
        };
      });
      return _assign({}, state, {
        sections: updatedSections,
        current_problem_id: problemId,
      });
    }
    default:
      return state;
  }
};
